/* eslint-disable */
import React, { useContext, useState } from 'react'
import { TextField, Button, Container, Typography, Box, Paper } from '@mui/material'
import { useApiGet } from '../../apiCalls/useApi'
import loginApi from '../../apiCalls/loginApi'
import Cookies from 'js-cookie'
import { AuthContext } from '../../Auth'
import { useNavigate } from 'react-router-dom'

const Login: React.FC = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errors, setErrors] = useState({ email: '', password: '' })
  const { setAuth } = useContext(AuthContext)
  const navigate = useNavigate()

  const userLogin = useApiGet(loginApi)

  const validate = () => {
    let tempErrors = { email: '', password: '' }
    if (!email) tempErrors.email = 'Email is required'
    else if (!/\S+@\S+\.\S+/.test(email)) tempErrors.email = 'Email is not valid'
    if (!password) tempErrors.password = 'Password is required'
    if (password.length < 8 || password.length > 20)
      tempErrors.password = 'Password must be between 8 and 20 characters'
    setErrors(tempErrors)
    return Object.values(tempErrors).every((x) => x === '')
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (validate()) {
      userLogin({ email, password }).then((res: any) => {
        if (!res || !res.token) {
          let tempErrors = { email: '', password: '' }
          tempErrors.password = 'Invalid email or password'
          setErrors(tempErrors)
          return
        }
        const token = res.token
        Cookies.set('auth_token', token)
        setAuth(true)
        navigate('/')
      })
    }
  }

  return (
    <Container
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper elevation={3} sx={{ mt: 8, p: 4, height: '430px', width: '350px' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 2,
            }}
          >
            <img src='/choosePageLogo.svg' alt='Company Logo' style={{ maxWidth: '40%' }} />
          </Box>
          <Typography component='h1' variant='h5' sx={{ marginBottom: 2 }}>
            Sign in
          </Typography>
          <form onSubmit={handleSubmit} style={{ width: '100%', marginTop: 1 }}>
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              id='email'
              label='Email Address'
              name='email'
              autoComplete='email'
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={Boolean(errors.email)}
              helperText={errors.email}
            />
            <TextField
              variant='outlined'
              margin='normal'
              fullWidth
              name='password'
              label='Password'
              type='password'
              id='password'
              autoComplete='current-password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              error={Boolean(errors.password)}
              helperText={errors.password}
            />
            <Button
              type='submit'
              fullWidth
              variant='contained'
              color='primary'
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>
            <Button fullWidth color='secondary' onClick={() => console.log('Forgot password')}>
              Forgot password?
            </Button>
          </form>
        </Box>
      </Paper>
    </Container>
  )
}

export default Login
